export const VALID_WALLET_ADDRESS_REGEX =
  /^(0x[a-fA-F0-9]{40})$|^[a-z0-9]+[a-z0-9-]*[a-z0-9]+.eth$/i;
